<div class="nim__content-area">
  <div id="switchStationModal" class="modal is-touch is-short" [ngClass]="{'is-open': (isModalOpen$ | async)}">
    <div class="modal__content">
      <div class="modal__header">
        <h2 class="h2">Enter Station Name</h2>
      </div>
      <div class="modal__body pt0 pr0 flex">
        <div class="container col-12">
          <div class="row no-edge-gutters">
            <div class="col-11">
              <div>
                <p class="h4 gray-40">Changing Station Name will not update Modbus. Only use in simulate mode.</p>
              </div>
              <br>
              <div>
                <p class="h4 gray-40">For switching to a remote storage, enter the name in <span class="italic">RemoteStorageName&#64;ClinicPartyId</span> format.</p>
              </div>
              <div class="form-group__icon-container">
                <input ncFocus #stationNameInput type="text" class="form-control" id="stationNameInput" [(ngModel)]="stationName"
                (keyup.enter)="onSwitchClick()">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal__footer flex justify-content-between">
        <button id="btnCloseSwitchModal" (click)="onCancelClick()" class="btn btn--true-blue-inverse">Cancel</button>
        <button id="btnSwitchConfirm" (click)="onSwitchClick()" [disabled]="!stationName" class="btn btn--true-blue">Switch
          Station</button>
      </div>
    </div>
  </div>
